// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2p51v","buttons":"PendingPaymentAlert_buttons__10Btv"};